import { gql } from '__generated__'

export const UpdateSourceStatus = gql(/* GraphQL */ `
    mutation UpdateSourceStatus(
        $rosterCandidateIds: [ID!]
        $rosterId: ID
        $candidateIds: [ID!]
        $sourceStatus: RosterSourceStatus!
    ) {
        updateRosterCandidateSourceStatus(
            rosterCandidateIds: $rosterCandidateIds
            rosterId: $rosterId
            candidateIds: $candidateIds
            sourceStatus: $sourceStatus
        ) {
            message
            success
        }
    }
`)
